/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CashIcon = /*#__PURE__*/ createSvgIcon(
  'CashIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M11.5 11a2.411 2.411 0 01-1.77-.73A2.41 2.41 0 019 8.5c0-.694.243-1.285.73-1.77A2.411 2.411 0 0111.5 6a2.41 2.41 0 011.77.73c.487.485.73 1.076.73 1.77a2.41 2.41 0 01-.73 1.77 2.411 2.411 0 01-1.77.73zm-6 2c-.412 0-.766-.147-1.06-.441a1.446 1.446 0 01-.44-1.06V5.494c0-.413.147-.765.44-1.056A1.45 1.45 0 015.5 4h12c.413 0 .766.147 1.06.441.293.294.44.647.44 1.06v6.005c0 .413-.147.765-.44 1.056A1.45 1.45 0 0117.5 13h-12zM7 11.5h9c0-.417.147-.772.44-1.065.294-.293.647-.44 1.06-.44V7c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 0116 5.5H7c0 .417-.147.772-.44 1.065-.294.293-.647.44-1.06.44V10c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06zm8.75 4.5H2.5c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 011 14.5V6.75c0-.213.071-.39.214-.534A.72.72 0 011.746 6c.21 0 .39.072.535.216a.72.72 0 01.219.534v7.75h13.25c.213 0 .39.072.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CashIcon;
